// extracted by mini-css-extract-plugin
export default {"loadingIcon":"index_loadingIcon__0Kd2s","spin":"index_spin__Ns+mK"};